var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonClient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.5C10.29 4.5 8.5 6.29 8.5 8.5C8.5 10.71 10.29 12.5 12.5 12.5C14.71 12.5 16.5 10.71 16.5 8.5C16.5 6.29 14.71 4.5 12.5 4.5ZM14.5 8.5C14.5 7.4 13.6 6.5 12.5 6.5C11.4 6.5 10.5 7.4 10.5 8.5C10.5 9.6 11.4 10.5 12.5 10.5C13.6 10.5 14.5 9.6 14.5 8.5ZM18.5 17.5C18.3 16.79 15.2 15.5 12.5 15.5C9.8 15.5 6.7 16.79 6.5 17.51V18.5H18.5V17.5ZM4.5 17.5C4.5 14.84 9.83 13.5 12.5 13.5C15.17 13.5 20.5 14.84 20.5 17.5V20.5H4.5V17.5Z",
    fill: "#48454F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonClient);
export default __webpack_public_path__ + "static/media/PersonClient.250ff48683f0d84eefc678c45c311245.svg";
export { ForwardRef as ReactComponent };